export enum Path {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  VERIFY_EMAIL_SENT = 'VERIFY_EMAIL_SENT',
  ACCEPT_INVITATION = 'ACCEPT_INVITATION',
  ENTERPRISE_SSO = 'ENTERPRISE_SSO',
  PROFILE = 'PROFILE',
  LOGOUT = 'LOGOUT',
  COMPANIES = 'COMPANIES',
  COMPANY = 'COMPANY',
  PERIOD = 'PERIOD',

  // RD_TAX_CREDIT routes
  RD_TAX_CREDIT = 'RD_TAX_CREDIT',
  COMPANY_INFO = 'ENTERPRISE_COMPANY_INFO',
  RD_PROJECTS = 'ENTERPRISE_RD_PROJECTS',
  RD_DATA_SOURCES = 'ENTERPRISE_RD_DATA_SOURCES',
  PAYROLL_QRE = 'ENTERPRISE_PAYROLL_QRE',
  ACCOUNTING_QRE = 'ENTERPRISE_ACCOUNTING_QRE',
  CREDIT_CALCULATION = 'ENTERPRISE_CREDIT_CALCULATION',
  EXPORT_TAX = 'ENTERPRISE_EXPORT_TAX',

  // SRED (Canadian R&D) routes
  SRED_TAX_CREDIT = 'SRED_TAX_CREDIT',
  SRED_PAYROLL_EXPENSES = 'ENTERPRISE_SRED_PAYROLL_EXPENSES',
  SRED_PROJECTS = 'ENTERPRISE_SRED_PROJECTS',

  // ASC_350_40 routes
  ASC_350_40 = 'ASC_350_40',
  ASC_DATA_SOURCES = 'ENTERPRISE_ASC_DATA_SOURCES',
  ASC_PROJECTS = 'ENTERPRISE_ASC_PROJECTS',
  EXPORT_ASC = 'ENTERPRISE_EXPORT_ASC',
  ASC_WAGES = 'ENTERPRISE_ASC_WAGES',

  MAINTENANCE_MODE = 'MAINTENANCE_MODE',
  TEST_LARGE_FILE_UPLOAD = 'TEST_LARGE_FILE_UPLOAD',
}
